import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import AuthCard from "./AuthCard";
import { Button, Input } from "../../components/ui";
import { authService } from "../../services/auth";
import { useToast } from "../../context/ToastContext";

export default function Register() {
  const navigate = useNavigate();
  const toast = useToast();
  const [form, setForm] = useState({ displayName: "", email: "", phone: "", password: "", confirm: "" });
  const [errors, setErrors] = useState({});
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const set = (key) => (e) => setForm((p) => ({ ...p, [key]: e.target.value }));

  const validate = () => {
    const e = {};
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) e.email = "รูปแบบอีเมลไม่ถูกต้อง";
    if (form.password.length < 8) e.password = "รหัสผ่านต้องมีอย่างน้อย 8 ตัวอักษร";
    if (form.confirm !== form.password) e.confirm = "รหัสผ่านไม่ตรงกัน";
    setErrors(e);
    return !Object.keys(e).length;
  };

  const submit = async (ev) => {
    ev.preventDefault();
    setError("");
    if (!validate()) return;
    setLoading(true);
    try {
      await authService.register(form);
      toast("สร้างบัญชีสำเร็จ", "success");
      navigate("/terms?next=%2F", { replace: true });
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthCard title="สร้างบัญชีใหม่" subtitle="ใช้เวลาไม่ถึงนาที แล้วเริ่มคุยได้เลย" footer={<>มีบัญชีอยู่แล้ว? <Link to="/login">เข้าสู่ระบบ</Link></>}>
      <form onSubmit={submit} noValidate>
        <Input label="ชื่อที่แสดง" placeholder="เช่น มินต์" maxLength={20} value={form.displayName} onChange={set("displayName")} autoComplete="nickname" />
        <Input label="อีเมล" type="email" placeholder="you@example.com" value={form.email} onChange={set("email")} error={errors.email} autoComplete="email" />
        <Input label="เบอร์โทร" type="tel" inputMode="numeric" maxLength={10} placeholder="08xxxxxxxx" value={form.phone} onChange={set("phone")} autoComplete="tel" required />
        <Input label="สร้างรหัสผ่าน" type="password" value={form.password} onChange={set("password")} error={errors.password} hint="อย่างน้อย 8 ตัวอักษร" autoComplete="new-password" />
        <Input label="ยืนยันรหัสผ่าน" type="password" value={form.confirm} onChange={set("confirm")} error={errors.confirm} autoComplete="new-password" />
        {error ? <div className="error-text mb-8" role="alert">{error}</div> : null}
        <Button type="submit" variant="primary" block size="lg" disabled={loading}>{loading ? "กำลังสร้างบัญชี..." : "สร้างบัญชี"}</Button>
      </form>
      <p className="faint center mt-16" style={{ fontSize: 12 }}>การสมัครถือว่ารับทราบ <Link to="/terms">ข้อกำหนดและความเป็นส่วนตัว</Link></p>
    </AuthCard>
  );
}
